import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0f172a] text-[#fdfbf7] pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Massive wordmark */}
        <div className="border-b border-[#bfa15f]/30 pb-12 mb-12">
          <p className="text-[0.7rem] uppercase tracking-[0.32em] text-[#bfa15f] mb-6">
            Kinsi Bollinger Law
          </p>
          <h3 className="font-serif-display italic font-medium tracking-tight leading-[0.92] text-[3rem] sm:text-[5rem] lg:text-[8.5rem] text-[#fdfbf7]">
            Counsel.
            <span className="not-italic text-[#d9c188]"> Conviction.</span>
          </h3>
        </div>

        {/* Info grid */}
        <div className="grid grid-cols-12 gap-8 md:gap-10 text-sm">
          <div className="col-span-12 md:col-span-4">
            <p className="text-[0.7rem] uppercase tracking-[0.28em] text-[#bfa15f] mb-4">
              Direct
            </p>
            <a
              href="tel:8015024017"
              data-testid="footer-phone"
              className="font-serif-display text-3xl text-[#fdfbf7] hover:text-[#d9c188] transition-colors"
            >
              801.502.4017
            </a>
            <p className="mt-3 text-[#fdfbf7]/60 text-[0.85rem]">
              Salt Lake City, Utah
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-[0.7rem] uppercase tracking-[0.28em] text-[#bfa15f] mb-4">
              Practice
            </p>
            <ul className="space-y-2 text-[#fdfbf7]/75">
              <li>Employment Law</li>
              <li>Business Disputes</li>
              <li>Elder Law</li>
              <li>Personal Injury</li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-[0.7rem] uppercase tracking-[0.28em] text-[#bfa15f] mb-4">
              Of Counsel
            </p>
            <a
              href="https://www.tomchakskolout.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-firm-link"
              className="link-underline text-[#fdfbf7]"
            >
              Tomchak Skolout
            </a>
            <p className="mt-3 text-[#fdfbf7]/60 text-[0.85rem] leading-relaxed">
              All matters handled through the firm.
            </p>
          </div>

          <div className="col-span-12 md:col-span-2">
            <p className="text-[0.7rem] uppercase tracking-[0.28em] text-[#bfa15f] mb-4">
              Member
            </p>
            <ul className="space-y-2 text-[#fdfbf7]/75">
              <li>Utah State Bar</li>
              <li>UELA — Treasurer</li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-16 pt-8 border-t border-[#bfa15f]/20 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[0.7rem] uppercase tracking-[0.24em] text-[#fdfbf7]/55">
            &copy; {year} Kinsi Bollinger. All rights reserved.
          </p>
          <p className="text-[0.7rem] text-[#fdfbf7]/45 max-w-2xl leading-relaxed">
            Attorney advertising. Prior results do not guarantee a similar
            outcome. The information on this site is not legal advice and does
            not create an attorney-client relationship.
          </p>
        </div>
      </div>
    </footer>
  );
}
